import { Block, Flex, SimpleInput } from '@aloft/toolkit-sui';

import { setDepreciation } from '../../../../redux/features/actions/setDepreciation.ts';
import { selectExternalDepreciationDisplay } from '../../../../redux/features/selectors/depreciationSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';

export function ExternalDepreciation({ id }: { id: string }) {
  const dispatch = useAppDispatch();
  const value = useAppSelector((state: RootState) => selectExternalDepreciationDisplay(state, id));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setDepreciation({
        id,
        field: 'externalDepreciation',
        newValue: Number(event.target.value),
      }),
    );
  };

  return (
    <Block>
      <Flex gap="1rem" width="100%" justifyContent="space-between" alignItems="center">
        <SimpleInput
          id="externalDepreciation"
          onChange={handleChange}
          type="number"
          label="External Obsolescence"
          labelTypographyVariant="h4"
          precision={0}
          size="sm"
          prefix="$"
          useSeparator
          value={value}
        />
      </Flex>
    </Block>
  );
}
